import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required('Educator Name field is required.'),
  email: yup.string().trim().email().required('Email field is required.'),
  school_organization: yup
    .string()
    .trim()
    .required('School, Organization or District Name field is required.'),
  question: yup
    .string()
    .required('Question field is required.'),
  month: yup
    .string()
    .required('Month field is required.'),
  day: yup
    .string()
    .required('Day field is required.'),
  year: yup
    .string()
    .required('Year field is required.'),
  opt_in: yup
    .boolean()
    .oneOf(
      [true],
      "Please check the box if you agree with Discovery Education's Privacy Policy and the Nielsen Foundation’s Privacy Policy."
    )
    .required(),
});
